/** Team profiles for About Us — add bios, roles, photos, and links when ready */
export const teamMembers = [
  {
    name: 'Rohan Shivakumar',
    bio: 'Rohan is a freshman at Stanford University and is a co-founder of FlameFlux.',
    role: null,
    imageUrl: '/default-avatar.svg',
    linkedinUrl: 'https://www.linkedin.com/in/rohan-shivakumar-803070293/',
  },
  {
    name: 'Timothy Ha',
    bio: 'Timothy is a junior at Hampton High School and is a co-founder of FlameFlux.',
    role: null,
    imageUrl: '/timothyhapfp.png',
    linkedinUrl: 'https://www.linkedin.com/in/timothy-ha-a56435262/',
  },
];
